// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3-c0-","image":"Header_image__1Inh7","name":"Header_name__SGIOw","info":"Header_info__1Jp4V","infoRow":"Header_infoRow__3safj"};